<template>
	<div id="app">
		<keep-alive>
		<router-view :key="key" v-if="$route.meta.keepAlive"></router-view>
		</keep-alive>
		<router-view :key="key" v-if="!$route.meta.keepAlive"></router-view>
		<!-- 密码相关组件 -->
		<force-change-password-modal />
		<password-expire-warning-modal />
	</div>
</template>

<script>
	import {
		getUpdateLastTime,
	} from '@/api/api.js';
	// 引入密码相关组件
	import ForceChangePasswordModal from '@/components/ForceChangePasswordModal';
	import PasswordExpireWarningModal from '@/components/PasswordExpireWarningModal';
	export default {
		name: 'app',
		components: {
			ForceChangePasswordModal,
			PasswordExpireWarningModal
		},
		computed: {
			key() {
				// return this.$route.name
			}
		},
		mounted() {
			let refreshShow = localStorage.getItem('refreshShow');
			if (refreshShow == 'false') {
				let activeName = localStorage.getItem('activeName');
				if (!activeName) {
					localStorage.setItem('activeName', '/allcontent');
					this.$router.replace('/allcontent');
				}
				if (window.performance.navigation.type == 1) {
					localStorage.setItem('activeName', '/allcontent');
					this.$router.replace('/allcontent');
					// window.location.reload()
				} else {
					getUpdateLastTime().then(res => {}).catch(error => {});
					localStorage.setItem('activeName', '/allcontent');
					this.$router.replace('/allcontent');
					let token = localStorage.getItem('keyToken');
					if (token) {
						window.location.reload()
					}
				}
			}
		}
	}
</script>

<style>
	@import 'richText/richText.css';

	* {
		padding: 0;
		margin: 0;
	}

	#app {
		width: 100%;
		height: 100%;
		background-color: #ffffff;
	}

	.left-icon {
		width: 6px;
		height: 20px;
		background: #3377FF;
		border-radius: 18px 18px 18px 18px;
		opacity: 1;
	}

	.pad-2 {
		padding: 2px;
	}

	.wid-12 {
		width: 83.5%;
	}

	.wid-100 {
		width: 100%;
	}

	.cursor {
		cursor: pointer;
		/* margin-right: 3%; */
	}

	.online {
		font-weight: normal;
	}

	.wid-30 {
		width: 30%;
	}

	.wid-50 {
		width: 62%;
	}

	/deep/.clamp {
		/*    overflow: hidden !important;
    display:-webkit-box !important;
    -webkit-box-orient:vertical !important;
    -webkit-line-clamp:2 !important; */
	}
</style>
